(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lf-carrusel"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('[data-lf-car]').forEach(function(root){
      var rail=root.querySelector('[data-rail]'); if(!rail) return;
      var paso=function(){return Math.max(260, rail.clientWidth*0.8)};
      root.querySelector('[data-next]').addEventListener('click',function(){rail.scrollBy({left:paso(),behavior:'smooth'})});
      root.querySelector('[data-prev]').addEventListener('click',function(){rail.scrollBy({left:-paso(),behavior:'smooth'})});
      var down=false,x0=0,s0=0;
      rail.addEventListener('mousedown',function(e){down=true;x0=e.pageX;s0=rail.scrollLeft;rail.style.scrollSnapType='none'});
      window.addEventListener('mouseup',function(){if(down){down=false;rail.style.scrollSnapType=''}});
      rail.addEventListener('mousemove',function(e){if(!down) return; e.preventDefault(); rail.scrollLeft=s0-(e.pageX-x0)});
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lf-header"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var hd=document.querySelector('[data-lf-hd]'); if(!hd) return;
    var dr=hd.querySelector('[data-dr]');
    hd.querySelector('[data-abrir]').addEventListener('click',function(){dr.hidden=false;document.body.style.overflow='hidden'});
    dr.querySelectorAll('[data-cerrar]').forEach(function(b){b.addEventListener('click',function(){dr.hidden=true;document.body.style.overflow=''})});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!dr.hidden){dr.hidden=true;document.body.style.overflow=''}});
    // el contador del carrito se refresca cuando algo se agrega
    document.addEventListener('lf:cart',function(e){var n=hd.querySelector('[data-lf-cart]');if(n&&e.detail&&typeof e.detail.count==='number')n.textContent=e.detail.count});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lf-hero"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('[data-lf-hs]').forEach(function(root){
      var track=root.querySelector('[data-track]'), slides=[].slice.call(root.querySelectorAll('[data-slide]'));
      var dots=[].slice.call(root.querySelectorAll('[data-dot]')), infos=[].slice.call(root.querySelectorAll('[data-info]'));
      var fill=root.querySelector('[data-fill]'), cur=root.querySelector('[data-cur]');
      var seg=(parseInt(root.dataset.seg,10)||7)*1000, i=0, t0=0, raf=null, pausa=false;
      var quieto=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      root.style.setProperty('--lf-seg', (seg/1000)+'s');
      function ir(n){
        i=(n+slides.length)%slides.length;
        track.style.transform='translateX(-'+(i*100)+'%)';
        slides.forEach(function(s,k){s.classList.toggle('is-on',k===i)});
        dots.forEach(function(d,k){ d.classList.remove('is-on'); if(k===i){ void d.offsetWidth; d.classList.add('is-on'); } });
        infos.forEach(function(x,k){x.classList.toggle('is-on',k===i)});
        if(cur) cur.textContent=(i+1<10?'0':'')+(i+1);
        t0=performance.now();
      }
      function loop(now){
        if(!pausa && !quieto && slides.length>1){
          var p=Math.min(1,(now-t0)/seg);
          if(fill) fill.style.width=(p*100)+'%';
          if(p>=1) ir(i+1);
        }
        raf=requestAnimationFrame(loop);
      }
      ir(0);
      if(slides.length>1){
        root.querySelector('[data-next]').addEventListener('click',function(){ir(i+1)});
        root.querySelector('[data-prev]').addEventListener('click',function(){ir(i-1)});
        dots.forEach(function(d){d.addEventListener('click',function(){ir(parseInt(d.dataset.dot,10))})});
        root.addEventListener('mouseenter',function(){pausa=true}); root.addEventListener('mouseleave',function(){pausa=false;t0=performance.now()});
        var x0=null;
        root.addEventListener('touchstart',function(e){x0=e.touches[0].clientX;pausa=true},{passive:true});
        root.addEventListener('touchend',function(e){ pausa=false; t0=performance.now(); if(x0===null) return; var dx=e.changedTouches[0].clientX-x0; if(Math.abs(dx)>40) ir(i+(dx<0?1:-1)); x0=null; },{passive:true});
        document.addEventListener('visibilitychange',function(){ pausa=document.hidden; t0=performance.now(); });
        raf=requestAnimationFrame(loop);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lf-producto"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var root=document.querySelector('[data-lf-pp]'); if(!root) return;
    var imgs=[].slice.call(root.querySelectorAll('.lf-pp__img')), thumbs=[].slice.call(root.querySelectorAll('[data-thumbs] button'));
    function muestra(i){ imgs.forEach(function(im,k){im.classList.toggle('is-on',k===i)}); thumbs.forEach(function(t,k){t.classList.toggle('is-on',k===i)}); }
    muestra(0);
    thumbs.forEach(function(t){ t.addEventListener('click',function(){ muestra(parseInt(t.dataset.i,10)); }); });
    var lb=root.querySelector('[data-lb]'), lbi=root.querySelector('[data-lb-img]');
    function abreLb(){ var on=imgs.filter(function(i){return i.classList.contains('is-on')})[0]; if(!on) return; lbi.src=on.currentSrc||on.src; lb.hidden=false; }
    root.querySelector('[data-main]').addEventListener('click',abreLb);
    lb.addEventListener('click',function(){lb.hidden=true});
    var qty=root.querySelector('[data-qty]'), qty2=root.querySelector('[data-qty2]');
    root.querySelector('[data-menos]').addEventListener('click',function(){qty.value=Math.max(1,(parseInt(qty.value,10)||1)-1);qty2.value=qty.value});
    root.querySelector('[data-mas]').addEventListener('click',function(){qty.value=(parseInt(qty.value,10)||1)+1;qty2.value=qty.value});
    qty.addEventListener('change',function(){qty2.value=Math.max(1,parseInt(qty.value,10)||1);qty.value=qty2.value});
    var variants=[]; try{ variants=JSON.parse(root.dataset.variants||'[]'); }catch(e){}
    var sel=root.querySelector('[data-var]'), idIn=root.querySelector('[data-id]'), add=root.querySelector('[data-add]');
    function dinero(c){ return '$' + (c/100).toLocaleString('es-MX',{minimumFractionDigits:2,maximumFractionDigits:2}); }
    if(sel){ sel.addEventListener('change',function(){
      var v=variants.filter(function(x){return String(x.id)===sel.value})[0]; if(!v) return;
      idIn.value=v.id; add.disabled=!v.available; add.textContent=v.available?'Agregar a carrito':'Agotado';
      root.querySelector('[data-p]').textContent=dinero(v.price); root.querySelector('[data-p2]').textContent=dinero(v.price);
      var cp=root.querySelector('[data-cp]'); if(v.compare_at_price&&v.compare_at_price>v.price){cp.hidden=false;cp.textContent=dinero(v.compare_at_price);} else cp.hidden=true;
      if(v.featured_image&&v.featured_image.position){ muestra(v.featured_image.position-1); }
    }); }
    var form=root.querySelector('#lf-form'), ok=root.querySelector('[data-ok]');
    form.addEventListener('submit',function(e){
      e.preventDefault(); add.disabled=true; var txt=add.textContent; add.textContent='Agregando…';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:parseInt(idIn.value,10),quantity:parseInt(qty2.value,10)||1})})
      .then(function(r){ if(!r.ok) throw new Error('no'); return r.json(); })
      .then(function(){ return fetch('/cart.js').then(function(r){return r.json()}); })
      .then(function(c){ ok.hidden=false; add.textContent='Agregado ✓'; document.dispatchEvent(new CustomEvent('lf:cart',{detail:{count:c.item_count}})); document.dispatchEvent(new CustomEvent('cart:update',{detail:{resource:c}})); setTimeout(function(){add.textContent=txt;add.disabled=false},1800); })
      .catch(function(){ add.disabled=false; add.textContent=txt; form.submit(); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
